import type { CSSProperties, ReactNode } from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

const TabPanelStyles = styled.div`
  flex-grow: 1;
`;

type Props = {
  activePage?: string | number;
  index?: number;
  children?: ReactNode;
  value: string | number;
  title: string;
  style?: CSSProperties;
  className?: string;
};

const TabPanel = ({
  activePage,
  index = 0,
  children,
  value,
  style,
  className
}: Props) => {
  'use memo';

  const isActive = value === activePage || value === index;

  return (
    <TabPanelStyles
      role="tabpanel"
      hidden={!isActive}
      className={classNames(className, 'tab-panel')}
      style={style}
    >
      {isActive && children}
    </TabPanelStyles>
  );
};

export default TabPanel;
